import React from "react";

function CheckIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 80.588 61.158"
      fill="#231f20"
      {...props}
    >
      <path d="M29.658 61.157a4.673 4.673 0 01-3.305-1.369L1.37 34.808a4.674 4.674 0 010-6.611 4.673 4.673 0 016.611 0l21.485 21.481 42.96-48.117a4.675 4.675 0 116.975 6.227L33.145 59.595a4.678 4.678 0 01-3.355 1.56l-.132.002z" />
    </svg>
  );
}

export default CheckIcon;
